export const APP_NAME = 'asset-acquisition';
